<template>
  <!-- <div class="button-wrapper"> -->
  <button
    :class="[visible ? 'actionButton' : 'export-button-hidden']"
    :disabled="generateCsv"
    @click="exportContacts()"
    v-tooltip="{
      content: 'Please wait while we export your contacts.',
      trigger: 'click',
      show: generateCsv,
      placement: visible ? 'bottom' : 'right',
    }"
    data-test="export-contacts-button"
  >
    Export {{ buttonLabel }}
  </button>

  <!-- </div> -->
</template>

<script>
import VTooltip from 'v-tooltip';
import axios from 'axios';
import {saveAs} from 'file-saver';

export default {
  name: 'export-contacts',
  components: {VTooltip},
  data() {
    return {
      generateCsv: false,
      buttonLabel: 'Contacts',
      postData: {},
      endpointType: 'contacts',
    };
  },
  methods: {
    exportContacts() {
      if (!this.generateCsv) {
        axios
          .post('/api/?entity=' + this.endpointType + '&action=generate' + this.buttonLabel + 'Export', this.postData)
          .then(() => {
            this.generateCsv = true;
            this.exportContacts();
          });
      } else {
        setTimeout(() => {
          axios
            .post(
              '/api/?entity=' + this.endpointType + '&action=export' + this.buttonLabel + 'ReadyForDownload',
              this.postData
            )
            .then(response => {
              return response.data.data;
            })
            .then(isReadyResponse => {
              const filename = isReadyResponse.filename,
                isReady = isReadyResponse.is_ready;
              if (isReady) {
                axios
                  .post(
                    '/api/?entity=' + this.endpointType + '&action=download' + this.buttonLabel + 'Export',
                    this.postData
                  )
                  .then(csv => {
                    let blob = new Blob([csv.data], {type: 'data:text/csv;charset=utf-8,%EF%BB%BF'});
                    saveAs(blob, filename);
                    this.generateCsv = false;
                  });
              } else {
                this.exportContacts();
              }
            });
        }, 5000);
      }
    },
  },
  mounted() {
    this.postData.type = this.type;

    if (!!this.campaignId) {
      this.postData.campaign_id = this.campaignId;
      this.buttonLabel = 'Subscribers';
      this.endpointType = 'campaigns';
    } else if (!!this.groupId) {
      this.postData.groupId = this.groupId;
      this.buttonLabel = 'Members';
      this.endpointType = 'groups';
    }
  },
  props: {
    type: {
      type: String,
      required: true,
    },
    campaignId: {
      type: Number,
      required: false,
    },
    groupId: {
      type: Number,
      required: false,
    },
    visible: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.export-button-hidden {
  visibility: hidden;
  width: 0;
  height: 0;
  position: relative;
  top: 15px;
  left: -0;
  padding: 0;
  display: none;
}
</style>
